import { render, staticRenderFns } from "./issue.vue?vue&type=template&id=e7325f12&scoped=true&"
import script from "./issue.vue?vue&type=script&lang=js&"
export * from "./issue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7325f12",
  null
  
)

export default component.exports